import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class ModuloRidContrattiVenditaService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.baseUrlFlussi = `${services.ask_base_flussi.url}`
    this.filemanager = new FileManager()
  }

  async getContrattiInattivi(opts = {}){
    let items = []
    let totalItems = 0

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/contratti/vendita/inattivi/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async getContrattiWithIban(opts = {}){
    let items = []
    let totalItems = 0

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/contratti/vendita/attivi/with-iban/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async getContrattiWithNoIban(opts = {}){
    let items = []
    let totalItems = 0

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/contratti/vendita/attivi/no-iban/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  // async downloadModuloRidZip(typeRid, unique, filters){
  //   const url = `${this.baseUrl}/contratti/vendita/modulo-rid/zip`
  
  //   try {
  //     const res = await this.http({
  //       url,
  //       method: 'POST',
  //       data: {
  //         type_rid: typeRid,
  //         unique: unique,
  //         filters,
  //       },
  //       responseType: 'blob',
  //     })
      
  //     const blob = new Blob([res.data], {type: 'application/zip'});
  //     console.log(blob);
  //     const fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
  
  //     const downloadUrl = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = downloadUrl;
  //     link.setAttribute('download', fileName);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (err) {
  //     this.eventBus.emit('data-load-error', {message: err, url})
  //   } finally {
  //     this.eventBus.emit('data-loaded')
  //   }
  // }


  // async downloadModuloRidZip(view, filters){
  //   let error;
  //   let items;
  //   const url = `${this.baseUrl}/contratti/vendita/modulo-rid/zip` 
  //   try {
  //     const res = await this.http({
  //       url,
  //       method: 'POST',
  //       data: {
  //         view,
  //         filters,
  //       },
  //         responseType: view ? 'json' : 'blob',
  //     })
  //     if (view) {
  //       items = res.data.path;
  //       this.visualizzaPDF(items)
  //       .then((res)=> {
  //         const path = URL.createObjectURL(res.items);
  //         window.open(path);
  //       })
  //     }else{
  //       if (res.data.size) {
  //         this.filemanager.download(res)
  //       } else {
  //         error = 'Non è possibile creare un modulo rid senza coordinate bancarie';
  //       }
  //     }
  //   } catch (err) {
  //       this.eventBus.emit('data-load-error', {message: err, url})
  //   } finally {
  //     // this.eventBus.emit('data-loaded')  
  //     if (error) {
  //       this.eventBus.emit('data-load-error', {message: error})
  //     }else{
  //       this.eventBus.emit('data-loaded')
  //     }
  //   }

  // }

  // async downloadModuloRidZip(method, filters){
  //   let error;
  //   let items;
  //   const url = `${this.baseUrl}/contratti/vendita/modulo-rid/zip` 
  //   try {
  //     const res = await this.http({
  //       url,
  //       method: 'POST',
  //       data: {
  //         method,
  //         filters,
  //       },
  //         responseType: method == 'view' ? 'json' : 'blob',
  //     })
  //     if (method == 'view') {
  //       items = res.data.path;
  //       this.visualizzaPDF(items)
  //       .then((res)=> {
  //         const path = URL.createObjectURL(res.items);
  //         window.open(path);
  //       })
  //     }else if(method == 'download'){
  //       if (res.data.size) {
  //         this.filemanager.download(res)
  //       } else {
  //         error = 'Non è possibile creare un modulo rid senza coordinate bancarie';
  //       }
  //     }else{
  //       this.eventBus.emit('data-load-success', {message: 'Modulo Rid generato'})
  //     }
  //   } catch (err) {
  //       this.eventBus.emit('data-load-error', {message: err, url})
  //   } finally {
  //     // this.eventBus.emit('data-loaded')  
  //     if (error) {
  //       this.eventBus.emit('data-load-error', {message: error})
  //     }else{
  //       this.eventBus.emit('data-loaded')
  //     }
  //   }

  // }

  async scaricaModuloRid(filters){
    const url = `${this.baseUrl}/scarica-moduli-rid`;
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: {
          filters
        },
        responseType: 'blob',
      })
      this.filemanager.download(res)
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }


  async getElencoModuliRid(){
    const url = `${this.baseUrl}/elenco-moduli-rid`
    let items
    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items  
  }

  async anteprimaModuloRid(filters){
    let items;
    const url = `${this.baseUrl}/anteprima-modulo-rid` 
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: {filters},
        // responseType: 'blob',
      })
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
          items,
      }
    }
  }

  async generaModuloRid(metod, filters){
    let items;
    const url = `${this.baseUrl}/genera-moduli-rid` 
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: {metod, filters},
      })
      this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
          items,
      }
    }
  }



  async visualizzaPDF(path){
    const url = `${this.baseUrl}/visualizza-modulo-rid`
    let items;
    try {
      const res = await this.http({
        url, 
        method: 'POST',
        data: { url: path },
        responseType: 'blob',
      })
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async signModuloRid(id){
    let items;
    let msg;
    const url = `${this.baseUrlFlussi}/eSign/invia-richiesta-modulo-rid`

    try {
      const res = await this.http({
        url, 
        method: 'POST',
        data: { modulo_rid_id: id }
      })
      msg = 'Email per firmare il modulo rid inviata'
      this.eventBus.emit('data-load-success', {message: msg})
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async deleteModuloRid(id){
    // let items;
    let msg;
    const url = `${this.baseUrl}/elimina-modulo-rid`

    try {
      const res = await this.http({
        url, 
        method: 'POST',
        data: { modulo_rid_id: id }
      })
      msg = res.data;
      this.eventBus.emit('data-load-success', {message: msg})
      // items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        // return {
        //     items,
        // }
    }
  }




}
